import { RadioItem } from "@/components/MarketingPage/ScheduleDemoSuccessModal";
// import { SelectListItem } from "src/molecules/Select";

type SelectListItem = {
  label: string;
  value: string;
};

export const defaultRadioOptions: RadioItem[] = [
  {
    label: "Yes",
    value: "yes",
  },
  {
    label: "No",
    value: "no",
  },
];

export const sellCoursesOnlineOptions: RadioItem[] = [
  ...defaultRadioOptions,
  {
    label: "Looking to start",
    value: "Looking to start",
  },
  // {
  //   label: "In the past",
  //   value: "In the past",
  // },
  // {
  //   label: "Only offline",
  //   value: "Only offline",
  // },
];

export const contentCategoryList: SelectListItem[] = [
  {
    label: "Academics",
    value: "Academics",
  },
  {
    label: "Personality Development",
    value: "Personality Development",
  },
  {
    label: "Fitness",
    value: "Fitness",
  },
  {
    label: "Crypto",
    value: "Crypto",
  },
  {
    label: "Financing and Accounting",
    value: "Financing and Accounting",
  },
  {
    label: "IT & Software",
    value: "IT & Software",
  },
  {
    label: "Arts",
    value: "Arts",
  },
  {
    label: "Others",
    value: "Others",
  },
];

export const communityStrength: SelectListItem[] = [
  {
    label: "0 - 1000 followers",
    value: "0 - 1000 followers",
  },
  {
    label: "1000 -10k",
    value: "1000 -10k",
  },
  {
    label: "10k -100k",
    value: "10k -100k",
  },
  {
    label: "100k +",
    value: "100k +",
  },
];
